<template>
    <div
        class="use-custom-bg-color flex items-start gap-16 overflow-x-auto p-4"
        :class="{ 'dark-bg': useDarkBg }"
    >
        <div class="grid w-max grid-cols-[repeat(4,_auto)] items-center gap-4">
            <em class="col-span-4 justify-self-stretch text-center">{{ variant }} {{ href ? 'link' : 'button' }} – lg</em>
            <em class="pr-8">Default</em>
            <DsButton
                :destructive
                :href
                :on-dark-bg="useDarkBg"
                size="lg"
                :target
                :variant
                @click="handleBtnClick('lg')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                :href
                :leading
                :on-dark-bg="useDarkBg"
                size="lg"
                :target
                :variant
                @click="handleBtnClick('lg', 'leading')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                :href
                :on-dark-bg="useDarkBg"
                size="lg"
                :target
                :trailing
                :variant
                @click="handleBtnClick('lg', 'trailing')"
            >
                Button CTA
            </DsButton>

            <em>Disabled</em>
            <template v-if="!href">
                <DsButton
                    :destructive
                    disabled
                    :href
                    :on-dark-bg="useDarkBg"
                    size="lg"
                    :target
                    :variant
                    @click="handleBtnClick('lg')"
                >
                    Button CTA
                </DsButton>
                <DsButton
                    :destructive
                    disabled
                    :href
                    :leading
                    :on-dark-bg="useDarkBg"
                    size="lg"
                    :target
                    :variant
                    @click="handleBtnClick('lg', 'leading')"
                >
                    Button CTA
                </DsButton>
                <DsButton
                    :destructive
                    disabled
                    :href
                    :on-dark-bg="useDarkBg"
                    size="lg"
                    :target
                    :trailing
                    :variant
                    @click="handleBtnClick('lg', 'trailing')"
                >
                    Button CTA
                </DsButton>
            </template>
            <template v-else>
                <span class="justify-self-center">N/A</span>
                <span class="justify-self-center">N/A</span>
                <span class="justify-self-center">N/A</span>
            </template>
            <em>Loading</em>
            <DsButton
                :destructive
                :href
                loading
                :on-dark-bg="useDarkBg"
                size="lg"
                :target
                :variant
                @click="handleBtnClick('lg')"
            >
                Button CTA
            </DsButton>
        </div>

        <div class="grid w-max grid-cols-[repeat(3,_auto)] items-center justify-items-start gap-4">
            <em class="col-span-3 justify-self-stretch text-center">{{ variant }} {{ href ? 'link' : 'button' }} – md</em>
            <!-- <em>Default</em> -->
            <DsButton
                :destructive
                :href
                :on-dark-bg="useDarkBg"
                size="md"
                :target
                :variant
                @click="handleBtnClick('md')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                :href
                :leading
                :on-dark-bg="useDarkBg"
                size="md"
                :target
                :variant
                @click="handleBtnClick('md', 'leading')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                :href
                :on-dark-bg="useDarkBg"
                size="md"
                :target
                :trailing
                :variant
                @click="handleBtnClick('md', 'trailing')"
            >
                Button CTA
            </DsButton>

            <!-- <em>Disabled</em> -->
            <template v-if="!href">
                <DsButton
                    :destructive
                    disabled
                    :href
                    :on-dark-bg="useDarkBg"
                    size="md"
                    :target
                    :variant
                    @click="handleBtnClick('md')"
                >
                    Button CTA
                </DsButton>
                <DsButton
                    :destructive
                    disabled
                    :href
                    :leading
                    :on-dark-bg="useDarkBg"
                    size="md"
                    :target
                    :variant
                    @click="handleBtnClick('md', 'leading')"
                >
                    Button CTA
                </DsButton>
                <DsButton
                    :destructive
                    disabled
                    :href
                    :on-dark-bg="useDarkBg"
                    size="md"
                    :target
                    :trailing
                    :variant
                    @click="handleBtnClick('md', 'trailing')"
                >
                    Button CTA
                </DsButton>
            </template>
            <template v-else>
                <span class="justify-self-center">N/A</span>
                <span class="justify-self-center">N/A</span>
                <span class="justify-self-center">N/A</span>
            </template>
            <!-- <em>Loading</em> -->
            <DsButton
                :destructive
                :href
                loading
                :on-dark-bg="useDarkBg"
                size="md"
                :target
                :variant
                @click="handleBtnClick('md')"
            >
                Button CTA
            </DsButton>
        </div>

        <div class="grid w-max grid-cols-[repeat(3,_auto)] items-center justify-items-start gap-4">
            <em class="col-span-3 justify-self-stretch text-center">{{ variant }} {{ href ? 'link' : 'button' }} – sm</em>
            <!-- <em>Default</em> -->
            <DsButton
                :destructive
                :href
                :on-dark-bg="useDarkBg"
                size="sm"
                :target
                :variant
                @click="handleBtnClick('sm')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                :href
                :leading
                :on-dark-bg="useDarkBg"
                size="sm"
                :target
                :variant
                @click="handleBtnClick('sm', 'leading')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                :href
                :on-dark-bg="useDarkBg"
                size="sm"
                :target
                :trailing
                :variant
                @click="handleBtnClick('sm', 'trailing')"
            >
                Button CTA
            </DsButton>

            <!-- <em>Disabled</em> -->
            <template v-if="!href">
                <DsButton
                    :destructive
                    disabled
                    :href
                    :on-dark-bg="useDarkBg"
                    size="sm"
                    :target
                    :variant
                    @click="handleBtnClick('sm')"
                >
                    Button CTA
                </DsButton>
                <DsButton
                    :destructive
                    disabled
                    :href
                    :leading
                    :on-dark-bg="useDarkBg"
                    size="sm"
                    :target
                    :variant
                    @click="handleBtnClick('sm', 'leading')"
                >
                    Button CTA
                </DsButton>
                <DsButton
                    :destructive
                    disabled
                    :href
                    :on-dark-bg="useDarkBg"
                    size="sm"
                    :target
                    :trailing
                    :variant
                    @click="handleBtnClick('sm', 'trailing')"
                >
                    Button CTA
                </DsButton>
            </template>
            <template v-else>
                <span class="justify-self-center">N/A</span>
                <span class="justify-self-center">N/A</span>
                <span class="justify-self-center">N/A</span>
            </template>

            <!-- <em>Loading</em> -->
            <DsButton
                :destructive
                :href
                loading
                :on-dark-bg="useDarkBg"
                size="sm"
                :target
                :variant
                @click="handleBtnClick('sm')"
            >
                Button CTA
            </DsButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { DsButtonProps } from '@ds/form/input/DsButton.vue';
import DsButton from '@ds/form/input/DsButton.vue';
import { computed } from 'vue';

interface DsButtonSampleProps {
    destructive?: DsButtonProps['destructive'];
    href?: DsButtonProps['href'];
    variant: DsButtonProps['variant'];
    leading: DsButtonProps['leading'];
    trailing: DsButtonProps['trailing'];
    useDarkBg: boolean;
}

const props = defineProps<DsButtonSampleProps>();
const target = computed(() => (props.href ? '_blank' : undefined));

const handleBtnClick = (size: DsButtonProps['size'], showIcon?: 'leading' | 'trailing') => {
    const propsCopy = { ...props, size };

    if (showIcon !== 'leading') delete propsCopy.leading;
    if (showIcon !== 'trailing') delete propsCopy.trailing;

    console.log('DsButton clicked!', propsCopy);
};
</script>
